import React from "react";
import { useSelector } from "react-redux";
import ArrowLeftWithCircle from '../../assests/course/arrowLeftWithCircle.png';
import { onKeyDown } from "../../service";
import classes from './BackArrow.module.css';

const BackArrow = ({ text, onClick, isMenu }) => {
    const direction = useSelector(state => state.translate.direction);


    return (
        <div className={`${classes[direction]} ${classes.ArrowContainer}`}>
            <img className={classes.ArrowIcon} src={ArrowLeftWithCircle} alt="Arrow" onClick={() => { onClick && onClick() }} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => onClick && onClick())} />
            <h2 className={`${classes.Text} ${isMenu && classes.MenuText}`}> {text}</h2>
        </div>
    )
}

export default BackArrow;